export interface ConfirmDeleteDialogModel {
    actionText?: string;
    content?: string;
    defaultToYes: boolean;
    title?: string;
}
